import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The locations feature roots on queryKeys.allLocations (list + CRUD invalidation).
 *  Read hooks for individual records reuse their own existing keys:
 *  [queryKeys.location, id] for getLocationDetails,
 *  [queryKeys.companyLocationsWithSpaces, ...] for getLocationsWithSpaces,
 *  [queryKeys.locationCities] for getLocationCities,
 *  [queryKeys.locationFloorMaps, id] for getLocationFloorMaps,
 *  [queryKeys.locationTargets, ...] for getLocationTargets.
 *  INTERNAL — consumers use the exported hooks. */
export const locationsApi = createFeatureApi(queryKeys.allLocations);
